import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fd0f4634"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "stf-ls"
};
const _hoisted_2 = {
  class: "stf-top"
};
const _hoisted_3 = {
  class: "stf-title"
};
const _hoisted_4 = {
  key: 0,
  class: "stf-hint"
};
const _hoisted_5 = {
  class: "stf-body"
};
import { ref, onMounted, onBeforeUnmount } from 'vue';
import SupportTrendChart from './SupportTrendChart.vue';
export default {
  __name: 'SupportTrendFull',
  setup(__props, {
    expose: __expose
  }) {
    const visible = ref(false);
    const rotateNeeded = ref(false);
    const title = ref('');
    const list = ref([]);
    const market = ref('had');
    const syncOrientation = () => {
      rotateNeeded.value = window.innerWidth <= window.innerHeight;
    };
    const show = (data, mk, t) => {
      if (!data || !data.length) return;
      list.value = data;
      market.value = mk || 'had';
      title.value = t || '支持量走势';
      syncOrientation();
      visible.value = true;
    };
    const close = () => {
      visible.value = false;
    };
    const onResize = () => {
      syncOrientation();
    };
    onMounted(() => {
      syncOrientation();
      const mql = window.matchMedia('(orientation: landscape)');
      const useMql = typeof mql.addEventListener === 'function';
      useMql ? mql.addEventListener('change', onResize) : window.addEventListener('orientationchange', onResize);
      window.addEventListener('resize', onResize);
    });
    onBeforeUnmount(() => {
      const mql = window.matchMedia('(orientation: landscape)');
      const useMql = typeof mql.removeEventListener === 'function';
      useMql ? mql.removeEventListener('change', onResize) : window.removeEventListener('orientationchange', onResize);
      window.removeEventListener('resize', onResize);
    });

    // eslint-disable-next-line no-undef
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [visible.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["stf-mask", {
          'stf-rotate': rotateNeeded.value
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(title.value), 1), rotateNeeded.value ? (_openBlock(), _createElementBlock("span", _hoisted_4, "↻ 请横屏查看")) : _createCommentVNode("", true), _createElementVNode("span", {
        class: "stf-close",
        onClick: close
      }, "✕")]), _createElementVNode("div", _hoisted_5, [_createVNode(SupportTrendChart, {
        list: list.value,
        market: market.value,
        dark: "",
        fill: ""
      }, null, 8, ["list", "market"])])])], 2)) : _createCommentVNode("", true)]);
    };
  }
};